var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.content,
    classes: _vm.classes,
    placement: _vm.placement,
  }),expression:"{\n    content,\n    classes,\n    placement,\n  }"}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }